import Repository from './repository'

export default {
    /**
     * 申込一覧データ取得処理
     * 
     * @param {*} params 入力パラメータ
     * @returns response
     */
    get (params) {
        return Repository.get(`/api/i202-order-lists/view`, {params})
    }
}
